import React from "react";
import "./ClientsAndMarkets.css";
const DesktopClientsAndMarkets = () => {
  return (
    <>
      <div className="RTF ClientsAndMarkets">
        <section className="">
          <div className="container">
            <div className="row">
              <div className="col-12 display-size-11">
                <h3>
                  <span style={{ color: "#002d5b" }}>
                    Our Clients and Markets
                  </span>
                </h3>
                <p>
                  WLF Mobile has been raising the bar for
                  electronic trading for over two decades. Institutional,
                  wholesale, retail and corporate treasury traders rely on our
                  deep liquidity pools, industry-defining trading technology and
                  best-in-className client service to trade confidently across
                  rates, credit, equities and money markets .
                </p>
                <p>
                  <br />
                  <br />
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DesktopClientsAndMarkets;
